import { environmentCommon } from './environment.common';

export const environment = {
	...environmentCommon,
	name: 'Staging',
	production: false,
	staging: true,
	dev: false,
	webApi: '/api',
};
